import { betaConfig } from "./betaConfig";
import { devConfig } from "./devConfig";
import { localConfig } from "./localConfig";
import { prodConfig } from "./prodConfig";

const env = process.env.REACT_APP_STAGE;

// const env = 'Dev';
export interface role {
  [key: string]: string;
}

export let roleConfig: role;

if (env === "Dev") {
  roleConfig = devConfig.roleConfig;
} else if (env === "Beta") {
  roleConfig = betaConfig.roleConfig;
} else if (env === "Prod") {
  roleConfig = prodConfig.roleConfig;
} else {
  roleConfig = localConfig.roleConfig;
}
